const translations = {
    helper: 'Set the replacement interval for each part. Wear is tracked as accumulated usage ÷ interval, and parts that reach their interval are flagged for service. Batteries wear by charge cycles; every other part by flights or flight hours.',
    intervalsUnavailable:
        'Service intervals for this asset could not be loaded. Close and reopen to try again.',
    noParts: 'This asset has no serviceable parts yet.',
    readOnly: 'Only an administrator can change service intervals.'
};

export default translations;
